//岗位层级
const POST_LEVEL = {
  1:'一',
  2:'二',
  3:'三',
  4:'四',
  5:'五',
  6:'六',
  7:'七',
  8:'八',
  9:'九',
  10:'十',
};
//发放金额类型
const AMOUNT_TYPE = {
	0:'全部一致',
	1:'按岗位职级发放'
}
//发放人群
const USER_TYPE = {
	0:'全部',
	1:'性别',
	2:'部门',
	3:'生日员工',
}
//发放时间类型
const TIME_TYPE = {
	0:'每月固定',
	1:'单独一次',
}
//性别
const RECHARGE_CHANNEL = {
	0:'系统',
	1:'社团长'
}
const ORDER_STATUS = {
	0:'待支付',
	1:'充值中', 
	2:'充值完成', 
	3:'已退款', 
	4:'已取消'
}
const ORDER_TYPE = {
	0:'电费',
	1:'话费', 
	2:'加油码', 
	3:'水费', 
	4:'燃气', 
	5:'加油卡',
}
const REFUND_STATUS = {
	0:'未退款',
	1:'部分退款', 
	2:'全部退款',
}
//0-提交成功 1-未提交 2-提交失败
const SUBMIT_STATUS = {
	0: '提交成功',
	1: '未提交',
	2: '提交失败',
}
//发放状态
const STATUS_TYPE = {
	0:'是',
	1:'否'
}
//日期
const DATE_TYPE = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28]
//订单状态
const ORDER_STATUS_TYPE = {
	1:'待支付',
	2:'待配货',
	3:'待报关',
	4:'配货中',
	5:'清关中',
	6:'待收货',
	7:'待评价',
	8:'已关闭',
	9:'已完成',
	10:'已退款',
}
//发放状态
const RECORD_STATUS_TYPE = {
	0:'成功',
	1:'失败'
}
//账户状态
const ISDELETE_TYPE = {
	0:'冻结',
	1:'正常'
}
/* 工业用电缴费 start*/
//缴费状态
const VENDOR_ORDER_STATUS_TYPE = {
	0:'待充值',
	1:'充值中',
	2:'已完成',
	3:'异常',
	4:'退单',
	5:'暂停'
}
//订单状态
const ELECTRIC_ORDER_STATUS_TYPE = {
	0:'待支付',
	1:'充值中',
	2:'已完成',
	3:'已退款',
	4:'已取消'
}
/* 工业用电缴费 end*/

export default {
  POST_LEVEL,
	
	ORDER_STATUS,
	RECHARGE_CHANNEL,
	SUBMIT_STATUS,
	REFUND_STATUS,
	ORDER_TYPE,
	//old
	AMOUNT_TYPE,
	USER_TYPE,
	TIME_TYPE,
	DATE_TYPE,
	STATUS_TYPE,
	ORDER_STATUS_TYPE,
	RECORD_STATUS_TYPE,
	ISDELETE_TYPE,
	VENDOR_ORDER_STATUS_TYPE,
	ELECTRIC_ORDER_STATUS_TYPE
}